var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"authList",style:({
    justifyContent: _vm.showList.length > 4 ? 'flex-start' : 'center',
  })},_vm._l((_vm.authorizedList),function(item){return _c('el-image',{key:item.id,staticClass:"authImg",attrs:{"src":item.fileUrl,"preview-src-list":_vm.showList}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }